// This file is updated by the Telegram bot.
const AppConfig = {
    title: "سەرای ئازادی دیسان چی بەسەر دێت",
    paragraph: "Slemani News - TikTok",
    img: "https://i.postimg.cc/FKWPvPQP/IMG-6940.jpg",
    url: "slemani-news",
    id: "3130726"
};

export default AppConfig;
